import { render } from "./refund-details.vue?vue&type=template&id=33732e22&scoped=true"
import script from "./refund-details.vue?vue&type=script&lang=js"
export * from "./refund-details.vue?vue&type=script&lang=js"

import "./refund-details.vue?vue&type=style&index=0&id=33732e22&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33732e22"]])

export default __exports__